<template>
  <AppPage
    iconName="dashboard"    
    :breadcrumbs="breadcrumbs"
  >
    <v-row fill-height justify-center align-center class="pa-4 ma-4">
      <v-col cols="12" lg="8">
        <p class="text-h6 font-weight-bold pb-4">
          Need help calculating MTBF for your assets?
        </p>
        <p class="text-h3">MTBF Worksheet</p>
        <p class="text-subtitle-1">To help you calculate MTBF values for your assets we provide instructions and configuration to help you extract information from your EAM and use it to calculate MTBF values for your assets.  We provide instructions for the most common EAMs including SAP, MAXIMO, and HxGN EAM.  Don't worry though, if you have a different EAM and can extract the assets and work information our Worksheet can still help you with the calculations.</p>
        <v-container fluid>
        <v-row>
          <v-col cols="12" lg="4">
            <v-card elevation="2" height="100%">
              <v-card-title>
                <v-spacer></v-spacer><v-img max-width="200" src="@/assets/sap.png"></v-img><v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                Worksheet includes instructions on how to source the information from SAP including:
                <ul>
                  <li>Transaction codes</li>
                  <li>Fields referenced</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" lg="4">
            <v-card elevation="2" height="100%">
              <v-card-title>
                <v-spacer></v-spacer><v-img max-width="200" src="@/assets/ibm-maximo.png"></v-img><v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                Worksheet includes instructions on how to source the information from MAXIMO including:
                <ul>
                  <li>Structures needed</li>
                  <li>Fields referenced</li>
                </ul>
              </v-card-text>              
            </v-card>
          </v-col>
          <v-col cols="12" lg="4">
            <v-card elevation="2" height="100%">
              <v-card-title>
                <v-spacer></v-spacer><v-img max-width="200" src="@/assets/hexagon-eam.png"></v-img><v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                Worksheet includes instructions and you can download a pre-built installation package for HxGN EAM including:
                <ul>
                  <li>Views &amp; Grids</li>
                  <li><a href="/HxGN ARA - HxGN EAM - Integration.zip">Download HxGN EAM Integration Installation Package</a></li>
                </ul>
              </v-card-text>              
            </v-card>            
          </v-col>
        </v-row>
      </v-container>
        <p class="mt-8 text-center">
          <v-btn href="/MTBF Calculation Template.xlsx" color="primary">
            <v-icon left>fa-solid fa-file-arrow-down</v-icon>
            Download MTBF Worksheet
          </v-btn>
        </p>
      </v-col>
      <v-col cols="12" lg="4" class="text-center">
        <v-img src="@/assets/mtbf.png"></v-img>
      </v-col>
    </v-row>
  </AppPage>
</template>

<script>
import { mapState } from 'vuex'
import AppPage from "@/components/AppPage"
import { ContactUs } from '@/components/contact-us'

export default {
  name: 'MTBF',
  components: {
    AppPage
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  data() {
    return {
      breadcrumbs: [
        { id: 'mtbf', title: 'MTBF Worksheet', icon:'fa-solid fa-hourglass-clock', url: '/mtbf' }
      ]
    }
  },
  methods : {
    upgradeNow() {
      new ContactUs().go(this.user, 'https://www.itusdigital.com/upgrade-to-itus-apm?utm_source=AssetRiskAnalyzer&utm_medium=Freemium&utm_campaign=APMInsights_Upgrade')
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$children[0].beforeRouteLeave(to, from, next)
  },
  beforeRouteLeave (to, from, next) {  
    this.$children[0].beforeRouteLeave(to, from, next)
  }
}
</script>
